module.exports = __webpack_public_path__ + "img/arrow_right_alt.25ddb0c3.svg";